import {useEffect} from 'react';
type Props = {
  title: string;
};
export const PageTitle = ({title}: Props): JSX.Element | null => {
  useEffect(() => {
    document.title = title;
    return () => {
      document.title = 'SweetProcess';
    };
  }, [title]);
  return null;
};
